/**
 * Created by Alex Aguilar on 6/24/2016.
 */
(function(){
    angular
        .module('acc-schedule', [])
        .directive('schedule', ['$translate', '$timeout', '$stateParams', schedule]);

    function schedule($translate, $timeout, $stateParams){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attributes){
            var steps = [
                '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00',
                '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'
            ];

            var dateParam = $stateParams.date;

            var newList = eval ("(" + attributes.scheduleData + ")");

            element.schedulerjs({
                'list': newList,
                'steps': steps,
                'pixelsPerHour': 60,
                'headName': $translate.instant('ADMIN_FLIGHT.TABLE.MODEL_AIRCRAFT')
            });

            $timeout(function(){
                var jQHover = $('.sjs-grid-overlay-col-title'),
                    title = "demo popover";

                jQHover.webuiPopover({
                    animation: true,
                    placement : 'right',
                    trigger: 'hover',
                    title : title,
                    content: function(elementObject){
                        var eleParentJQ = elementObject.$element.parent(),
                            values = eleParentJQ.data('values');

                        var content = '<ul class="list-unstyled">' +
                        '<li>' +
                        '<span class="bold">'+ $translate.instant('ADMIN_FLIGHT.NUMBER_FLIGHT') +': </span> ' +
                        '<span>'+values.flightNumber+'</span></li>'+
                        '<li>' +
                        '<span class="bold">'+ $translate.instant('ADMIN_FLIGHT.DEPARTURE_TIME') +': </span> ' +
                        '<span>'+values.start+'</span></li>'+
                        '<li>' +
                        '<span class="bold">'+ $translate.instant('ADMIN_FLIGHT.ARRIVAL_TIME') +': </span> ' +
                        '<span>'+values.end+'</span></li>'+
                        '<li>' +
                        '<span class="bold">'+ $translate.instant('ADMIN_FLIGHT.ROUTE') +': </span> ' +
                        '<span>'+values.route+'</span></li>'+
                        '</ul>' +
                        '<hr class="mt-1 mb-1">'+
                        '<ul class="list-inline">' +
                        '<li>' +
                        '<a href="#/adminFlight/'+values.flightId+'/edit/'+dateParam+'" class="bold web-ui-popover-adminFlight" title="'+$translate.instant('EDIT')+'">' +
                        '<i class="fa fa-pencil-square-o"></i> '+ $translate.instant('EDIT') +'' +
                        '</a>' +
                        '</li>'+
                        '<li>' +
                        '<a href="#/adminFlights" class="bold web-ui-popover-adminFlight" title="'+$translate.instant('ADMIN_FLIGHT.EDIT_CREW')+'">' +
                        '<i class="fa fa-plane"></i> '+ $translate.instant('ADMIN_FLIGHT.EDIT_CREW') +'' +
                        '</a>' +
                        '</li>'+
                        '</ul>';
                        return content;
                    },
                    closeable:true,
                    animation:'fade',
                    onShow: function($element) {
                        $(".web-ui-popover-adminFlight").on("click", function(){
                            WebuiPopovers.hideAll();
                        });
                    }
                 });

            }, 1000);
        }
    }
})();
